export default __webpack_public_path__ + "static/media/connect-1-o-1.daeb44de.jpg";